import { useTheme } from './ThemeProvider';
import styles from './ThemeSwitcher.module.css';
import { THEME_PREFS, type ThemePref, themeLabel } from './theme';

const ICON: Record<ThemePref, string> = {
  light: '☀️',
  dark: '🌙',
  system: '🖥️',
};

/**
 * Seletor de tema reutilizável (claro / escuro / sistema). Segmented control
 * acessível: `toolbar` por teclado, foco visível, rótulo por opção.
 *
 * `compact` esconde os rótulos só visualmente (nome acessível e title ficam).
 * Para hosts estreitos, como o card de autenticação, em que o limite é a
 * largura do contêiner — não a da viewport.
 */
export function ThemeSwitcher({ compact = false }: { compact?: boolean }) {
  const { pref, setPref } = useTheme();
  const groupClass = compact ? `${styles.group} ${styles.compact}` : styles.group;
  return (
    <div className={groupClass} role="toolbar" aria-label="Tema da interface">
      {THEME_PREFS.map((option) => {
        const active = pref === option;
        return (
          <button
            key={option}
            type="button"
            aria-pressed={active}
            className={active ? `${styles.btn} ${styles.active}` : styles.btn}
            onClick={() => setPref(option)}
            title={`Tema: ${themeLabel(option)}`}
          >
            <span aria-hidden="true">{ICON[option]}</span>
            <span className={styles.label}>{themeLabel(option)}</span>
          </button>
        );
      })}
    </div>
  );
}
